import OpenInNew from '@mui/icons-material/OpenInNew';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import type { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { WhenLoaded } from '@openx/components-core/lib/Loader/WhenLoaded';
import { EMPTY_LIST } from '@openx/constants/api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDealRevenueModifiers } from '../hooks/useDealRevenueModifiers';

const CONTAINER_SX: SxProps = { mb: 0.5, mt: 1 };

type RebateInfoProps = {
  index: number;
};

export const RebateInfo = ({ index }: RebateInfoProps) => {
  const { loadingAggregate, rebatesAggregate } = useDealRevenueModifiers();
  const { t } = useTranslation();

  const isLoadingCommercialAgreements = loadingAggregate[index];
  const rebates = rebatesAggregate[index] ?? EMPTY_LIST;
  const hasOnlyDspRebates = useMemo(() => rebates.every(rebate => !!rebate.demand_partner_id), [rebates]);
  const showAlert = rebates.length !== 0 && !hasOnlyDspRebates;

  return (
    <WhenLoaded loading={isLoadingCommercialAgreements} noPadding sx={CONTAINER_SX}>
      {showAlert && (
        <Alert severity="info" sx={CONTAINER_SX} data-test="deal-revenue-calculator-rebate-info">
          <Typography>{t('To check rebate details for specific brands, go to OpenX Unity.')}</Typography>

          <Button
            color="default"
            endIcon={<OpenInNew />}
            href="https://platform.openx.com/unity/monetization-settings/rebates/"
            sx={{ mt: 1 }}
            target="_blank"
            variant="contained"
          >
            {t('Go to OpenX Unity')}
          </Button>
        </Alert>
      )}
    </WhenLoaded>
  );
};
